// extracted by mini-css-extract-plugin
export default {"navbar":"navbar_navbar__eiNcb","logo":"navbar_logo__1SlrY","navLinks":"navbar_navLinks__hMc3j","menuIcon":"navbar_menuIcon__oPuuB","navLinksMobile":"navbar_navLinksMobile__Y-qKP"};